import { Nil } from '@aibees/shared/definition';
import { capitalize } from '@aibees/shared/utils';

export function formatCompanyLocation(location: Nil<string>[]) {
  return capitalize(location.filter(Boolean).join(', '));
}
